import { React } from "react";
import {
	InputField,
	SelectField,
	SelectFieldStatus,
	CustomDateField,
} from "../../../components/Form/FormComponents";
import { getFormattedDate } from "../../../utils/DateUtils";
import { getRequestValue, getUserName } from "../../../utils/Utils";
import { repairStatusOptions } from "../data";
import FileUpload from "./FileUpload";

/* eslint-disable react/prop-types */

export const RequestInformationAF = ({
	formData,
	fileInfo,
	handleFileUpload,
	invoiceLoading,
	receiptLoading,
	hardCopyReceipt,
	fileOneEnabled,
	fileTwoEnabled,
}) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			{/* <div className='form-group'>
				<label>BUSINESS INTEREST</label>
				<InputField name='businessInterest' value={formData?.businessId?.businessInterest} />
			</div> */}

			<div className='form-group'>
				<label>INVESTOR</label>
				<InputField name='investor' value={formData?.investorFinanceInfo?.name} />
			</div>

			<div className='form-group'>
				<label>APPRENTICE</label>
				<InputField name='apprentice' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>A.F TYPE</label>
				<SelectField name='type' value={formData?.type} options={["Quick", "Sponsored"]} />
			</div>

			<div className='form-group'>
				<label>AMOUNT TO RAISE</label>
				<InputField name='amountToRaise' value={formData?.amountToRaise} />
			</div>

			<div className='form-group'>
				<label>EXPECTED PROFIT</label>
				<InputField name='expectedProfit' value={formData?.expectedProfit} />
			</div>

			<div className='form-group'>
				<label>A.F DURATION</label>
				<InputField name='duration' value={formData?.tenure} />
			</div>

			<div className='form-group'>
				<label>PAYMENT TYPE</label>
				<SelectField name='paymentType' value={formData?.paymentType} options={["wallet", "bank", "card"]} />
			</div>

			<div className='form-group'>
				<label>INTEREST RATE</label>
				<InputField name='interestRate' value={formData?.interestRate} />
			</div>

			<div className='form-group'>
				<label>PROGRAM SAVINGS</label>
				<InputField name='programSavings' value={formData?.programSavings} />
			</div>

			<div className='form-group'>
				<label>BUSINESS TYPE</label>
				<InputField name='businessType' value={formData?.businessType} />
			</div>

			<div className='form-group'>
				<label>BUSINESS DESCRIPTION</label>
				<InputField name='businessDescription' value={formData?.businessDescription} />
			</div>

			<div className='form-group'>
				<label>PURPOSE</label>
				<InputField name='purpose' value={formData?.purpose} />
			</div>

			<div className='form-group'>
				<label>REQUEST</label>
				<InputField name='request' value={getRequestValue(formData)} />
			</div>

			<div className='form-group'>
				<label>LOGISTIC STATUS</label>
				<SelectField name='logistic status' value={formData?.logisticStatus || "N/A"} />
			</div>

			<div className='form-group'>
				<label>PAYMENT RECEIPT</label>
				<FileUpload
					name='paymentReceipt'
					isDisabled={!fileOneEnabled}
					isLoading={invoiceLoading}
					handleChange={handleFileUpload}
					fileInfo={fileInfo}
				/>
			</div>

			{formData?.logisticStatus && (
				<div className='form-group'>
					<label>PROOF OF PURCHASE</label>
					<FileUpload
						name='proofOfPurchase'
						isDisabled={!fileTwoEnabled}
						isLoading={receiptLoading}
						handleChange={handleFileUpload}
						fileInfo={hardCopyReceipt}
					/>
				</div>
			)}

			{/* {!except?.includes("approvalStatus") && (
				<div className='form-group'>
					<label>APPROVAL</label>
					<SelectFieldStatus
						name='approvalStatus'
						value={formData?.approvalStatus}
						type={formData?.approvalStatus?.toLowerCase()}
						options={["settled", "pending", "default"]}
					/>
				</div>
			)} */}
		</>
	);
};

export const RepairInformationAF = ({ formData, isEditable, handleInputChange }) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>BUSINESS INTEREST</label>
				<InputField name='businessInterest' value={formData?.businessId?.businessInterest} />
			</div>

			<div className='form-group'>
				<label>APPRENTICE</label>
				<InputField name='apprentice' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>AMOUNT TO RAISE</label>
				<InputField name='amountToRaise' value={formData?.amountToRaise} />
			</div>

			<div className='form-group'>
				<label>BUSINESS TYPE</label>
				<InputField name='businessType' value={formData?.businessType} />
			</div>

			<div className='form-group'>
				<label>FAULT</label>
				<InputField
					name='fault'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.fault}
				/>
			</div>

			<div className='form-group'>
				<label>REPAIRS FEE</label>
				<InputField
					name='repairFee'
					handleChange={handleInputChange}
					isEditable={isEditable}
					value={formData?.repairFee}
				/>
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='repairStatus'
					value={formData?.repairStatus}
					handleChange={handleInputChange}
					isEditable={isEditable}
					type={formData?.repairStatus?.toLowerCase()}
					options={repairStatusOptions}
				/>
			</div>
		</>
	);
};

export const RetainedInformationAF = ({ formData, isEditable, handleInputChange }) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>BUSINESS INTEREST</label>
				<InputField name='businessInterest' value={formData?.businessId?.businessInterest} />
			</div>

			<div className='form-group'>
				<label>INVESTOR</label>
				<InputField
					name='investor'
					value={formData?.investorId?.firstName + " " + formData?.investorId?.lastName}
				/>
			</div>

			<div className='form-group'>
				<label>APPRENTICE</label>
				<InputField name='apprentice' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>AMOUNT TO RAISE</label>
				<InputField name='amountToRaise' value={formData?.amountToRaise} />
			</div>

			<div className='form-group'>
				<label>EXPECTED PROFIT</label>
				<InputField name='expectedProfit' value={formData?.expectedProfit} />
			</div>

			<div className='form-group'>
				<label>A.F DURATION</label>
				<InputField name='duration' value={formData?.duration} />
			</div>

			<div className='form-group'>
				<label>PAYMENT TYPE</label>
				<SelectField name='paymentType' value={formData?.paymentType} options={["wallet", "bank", "card"]} />
			</div>

			<div className='form-group'>
				<label>INTEREST RATE</label>
				<InputField name='interestRate' value={formData?.interestRate} />
			</div>

			<div className='form-group'>
				<label>PROGRAM SAVINGS</label>
				<InputField name='programSavings' value={formData?.programSavings} />
			</div>

			<div className='form-group'>
				<label>BUSINESS TYPE</label>
				<InputField name='businessType' value={formData?.businessType} />
			</div>

			<div className='form-group'>
				<label>BUSINESS DESCRIPTION</label>
				<InputField name='businessDescription' value={formData?.businessDescription} />
			</div>

			<div className='form-group'>
				<label>PURPOSE</label>
				<InputField name='purpose' value={formData?.purpose} />
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='retainmentStatus'
					value={formData?.retainmentStatus}
					type={formData?.retainmentStatus?.toLowerCase()}
					handleChange={handleInputChange}
					isEditable={isEditable}
					options={["retained", "released"]}
				/>
			</div>
		</>
	);
};

export const InspectionInformationAF = ({
	formData,
	isEditable,
	handleInputChange,
	handleDateChange,
	formattedDate,
}) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>BUSINESS INTEREST</label>
				<InputField name='businessInterest' value={formData?.businessId?.businessInterest} />
			</div>

			<div className='form-group'>
				<label>INVESTOR</label>
				<InputField
					name='investor'
					value={formData?.investorId?.firstName + " " + formData?.investorId?.lastName}
				/>
			</div>

			<div className='form-group'>
				<label>APPRENTICE</label>
				<InputField name='apprentice' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>AMOUNT TO RAISE</label>
				<InputField name='amountToRaise' value={formData?.amountToRaise} />
			</div>

			<div className='form-group'>
				<label>EXPECTED PROFIT</label>
				<InputField name='expectedProfit' value={formData?.expectedProfit} />
			</div>

			<div className='form-group'>
				<label>A.F DURATION</label>
				<InputField name='duration' value={formData?.duration} />
			</div>

			<div className='form-group'>
				<label>PAYMENT TYPE</label>
				<SelectField name='paymentType' value={formData?.paymentType} options={["wallet", "bank", "card"]} />
			</div>

			<div className='form-group'>
				<label>INTEREST RATE</label>
				<InputField name='interestRate' value={formData?.interestRate} />
			</div>

			<div className='form-group'>
				<label>PROGRAM SAVINGS</label>
				<InputField name='programSavings' value={formData?.programSavings} />
			</div>

			<div className='form-group'>
				<label>BUSINESS TYPE</label>
				<InputField name='businessType' value={formData?.businessType} />
			</div>

			<div className='form-group'>
				<label>BUSINESS DESCRIPTION</label>
				<InputField name='businessDescription' value={formData?.businessDescription} />
			</div>

			<div className='form-group'>
				<label>PURPOSE</label>
				<InputField name='purpose' value={formData?.purpose} />
			</div>

			<div className='form-group'>
				<label>WARRANTY</label>
				<InputField
					name='warranty'
					value={formData?.warranty}
					handleChange={handleInputChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>INSPECTION ROUTINE</label>
				<SelectFieldStatus
					name='inspectionRoutine'
					value={formData?.inspectionRoutine}
					handleChange={handleInputChange}
					type={"success"}
					isEditable={isEditable}
					options={["weekly", "monthly", "bi-annually", "annually"]}
				/>
			</div>

			<div className='form-group'>
				<label>INSPECTION FEE</label>
				<InputField
					name='inspectionFee'
					value={formData?.inspectionFee}
					handleChange={handleInputChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>LAST INSPECTED</label>
				<CustomDateField
					name='lastInspected'
					value={formattedDate}
					handleChange={handleDateChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='inspectionStatus'
					isEditable={isEditable}
					value={formData?.inspectionStatus}
					type={formData?.inspectionStatus?.toLowerCase()}
					options={["ongoing", "completed"]}
					handleChange={handleInputChange}
				/>
			</div>
		</>
	);
};

export const MaintainedInformationAF = ({
	formData,
	isEditable,
	handleInputChange,
	handleDateChange,
	formattedDate,
}) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			<div className='form-group'>
				<label>BUSINESS INTEREST</label>
				<InputField name='businessInterest' value={formData?.businessId?.businessInterest} />
			</div>

			<div className='form-group'>
				<label>INVESTOR</label>
				<InputField
					name='investor'
					value={formData?.investorId?.firstName + " " + formData?.investorId?.lastName}
				/>
			</div>

			<div className='form-group'>
				<label>APPRENTICE</label>
				<InputField name='apprentice' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>AMOUNT TO RAISE</label>
				<InputField name='amountToRaise' value={formData?.amountToRaise} />
			</div>

			<div className='form-group'>
				<label>EXPECTED PROFIT</label>
				<InputField name='expectedProfit' value={formData?.expectedProfit} />
			</div>

			<div className='form-group'>
				<label>A.F DURATION</label>
				<InputField name='duration' value={formData?.duration} />
			</div>

			<div className='form-group'>
				<label>PAYMENT TYPE</label>
				<SelectField name='paymentType' value={formData?.paymentType} options={["wallet", "bank", "card"]} />
			</div>

			<div className='form-group'>
				<label>INTEREST RATE</label>
				<InputField name='interestRate' value={formData?.interestRate} />
			</div>

			<div className='form-group'>
				<label>PROGRAM SAVINGS</label>
				<InputField name='programSavings' value={formData?.programSavings} />
			</div>

			<div className='form-group'>
				<label>BUSINESS TYPE</label>
				<InputField name='businessType' value={formData?.businessType} />
			</div>

			<div className='form-group'>
				<label>BUSINESS DESCRIPTION</label>
				<InputField name='businessDescription' value={formData?.businessDescription} />
			</div>

			<div className='form-group'>
				<label>PURPOSE</label>
				<InputField name='purpose' value={formData?.purpose} />
			</div>

			<div className='form-group'>
				<label>WARRANTY</label>
				<InputField
					name='warranty'
					value={formData?.warranty}
					handleChange={handleInputChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>MAINTENANCE FEE</label>
				<InputField
					name='maintenanceFee'
					value={formData?.maintenanceFee}
					handleChange={handleInputChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>DUE DATE</label>
				<CustomDateField
					name='maintenanceDueDate'
					value={formattedDate}
					handleChange={handleDateChange}
					isEditable={isEditable}
				/>
			</div>

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='maintenanceStatus'
					value={formData?.maintenanceStatus}
					type={formData?.maintenanceStatus?.toLowerCase()}
					handleChange={handleInputChange}
					isEditable={isEditable}
					options={["Ongoing", "Completed"]}
				/>
			</div>
		</>
	);
};

// General
export const ApprenticeInformation = ({ formData }) => {
	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>Name</label>
				<InputField name='apprentice' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>DELIVERY ADDRESS</label>
				<InputField name='delivery_address' value={formData?.user?.homeAddress} />
			</div>

			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='phone_number' value={formData?.user?.phone} />
			</div>
		</div>
	);
};

export const InvestorInformation = ({ formData }) => {
	const { investorFinanceInfo } = formData;

	return (
		<div className='grid grid-cols-3 gap-3'>
			<div className='form-group'>
				<label>Name</label>
				<InputField name='investor' value={investorFinanceInfo?.name} />
			</div>

			<div className='form-group'>
				<label>ADDRESS</label>
				<InputField name='delivery_address' value={investorFinanceInfo?.address} />
			</div>

			<div className='form-group'>
				<label>PHONE NUMBER</label>
				<InputField name='phone_number' value={investorFinanceInfo?.phone} />
			</div>

			<div className='form-group'>
				<label>EMAIL</label>
				<InputField name='email' value={investorFinanceInfo?.email} />
			</div>
		</div>
	);
};
